<template>
    <div class="d-flex flex-column ">
        <!--         <v-card v-if="$vuetify.breakpoint.mdAndUp" flat class=" rounded-0" height="150" color="primary">
            <v-col class="d-flex align-center justify-center">
                <v-img width="350" max-width="300" src="@/assets/Logo-bt-06.png" />
            </v-col>
        </v-card> -->
        <v-card class="rounded-0" flat>
            <v-card class="rounded-0" flat>
                <ValidationObserver ref="obs" v-slot="{ invalid }">
                    <v-form v-model="valid" @submit.prevent="cambiarPass">
                        <v-card-text>
                            <v-row class="d-flex flex-column justify-center align-center">
                                <v-col cols="12" md="12" class="d-flex justify-center my-5">
                                    <v-img max-width="359" max-height="71px" src="@/assets/logo-web.png" contain />
                                </v-col>
                                <v-col cols="10" md="4">
                                    <div class="font-weight-regular primary--text text-h6 mb-0">
                                        NUEVA CONTRASEÑA
                                    </div>
                                </v-col>
                                <v-col cols="10" md="4" v-if="mensajeCambiarPass !== ''">
                                    <v-alert dark class="font-weight-regular text-body-2"
                                        icon="mdi-check-circle-outline" color="success">
                                        {{ mensajeCambiarPass }}
                                    </v-alert>
                                </v-col>
                                <v-col cols="10" md="4" v-if="mensajeCambiarPass !== ''">
                                    <v-btn block elevation="0" class="px-12 py-6 mt-3 mx-0 " color="primary"
                                        @click="goToLogin">
                                        INICIAR SESIÓN
                                    </v-btn>
                                </v-col>
                                <v-col cols="10" md="4" v-else>
                                    <v-alert class="rounded-0 font-weight-regular text-body-2" border="left"
                                        icon="mdi-alert-circle" colored-border color="orange darken-2">
                                        La contraseña debe tener 8 caracteres o más y al menos una letra mayúscula.
                                    </v-alert>
                                    <ValidationProvider vid="confirmation" rules="required|password_strong" v-slot="v">
                                        <v-text-field outlined v-model="confirmation" :error-messages="v.errors[0]"
                                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show1 ? 'text' : 'password'" name="password" label="Contraseña"
                                            @click:append="show1 = !show1"></v-text-field>
                                    </ValidationProvider>
                                    <ValidationProvider rules="required|confirmed:confirmation" v-slot="v">
                                        <v-text-field outlined v-model="password"
                                            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show2 ? 'text' : 'password'" :error-messages="v.errors[0]"
                                            label="Confirmar contraseña" class="input-group--focused"
                                            @click:append="show2 = !show2"></v-text-field>
                                    </ValidationProvider>
                                    <v-btn :disabled="invalid" block elevation="0" class="px-12 py-6 ma-0 "
                                        color="primary" type="cambiarPass">
                                        aceptar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-form>
                </ValidationObserver>
            </v-card>
        </v-card>
    </div>
</template>


<script>

import { mapActions, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    components: {

        ValidationObserver,
        ValidationProvider,
    },

    data() {
        return {
            hash: '',
            valid: false,
            show1: false,
            show2: false,
            password: '',
            confirmation: '',
            mensaje: '',
        }
    },
    computed: {
        ...mapGetters('notificaciones', ['loading']),
        ...mapGetters(['mensajeCambiarPass']),
    },

    created() {
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        this.hash = params.get('v')
        this.getValidation({ hash: this.hash })
    },
    methods: {
        ...mapActions('notificaciones', ['showSnack']),
        ...mapActions(['getValidation']),

        goToLogin() {
            this.$router.push('/Login').catch(() => { })
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        cambiarPass() {
            this.$refs.obs.validate().then((result) => {
                if (result) {
                    try {
                        this.getValidation({
                            hash: this.hash,
                            pwd: this.password
                        })
                    } catch (error) {
                        console.error('Error al cambiar la contraseña:', error);
                    }
                } else {
                }

            })
        }

    },

}

</script>

<style scoped>
.divider-grueso {
    height: 6ch;
    color: #fff;
}
</style>